import { FC, useMemo } from "react";
import ControlledSelect, { ControlledSelectProps } from "../../../ControlledInputs/ControlledSelect.tsx";
import useEquipmentKits from "../../../../api/hooks/useEquipmentKits/useEquipmentKits.ts";
import { KitConfig } from "../../../../api/hooks/useEquipmentKits/type.ts";

const LightSetUp: FC<Omit<ControlledSelectProps, "options">> = (props) => {
  const { kits, isFetching } = useEquipmentKits();

  const options = useMemo(() => {
    return kits?.map(el => ({
      value: el,
      label: KitConfig[el]
    })) || [];
  },[kits])

  return (
    <ControlledSelect disabled={isFetching} options={options} {...props} />
  );
};

export default LightSetUp;
